import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-audit-mode-label',
  template: `<span class="label audit">{{ 'Site.auditMode.label' | translate }}</span>`,
  styles: `
    .label {
      &.audit {
        background-color: #333;
      }
    }
  `,
  imports: [TranslatePipe],
})
export class AuditModeLabelComponent {}
